(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-competition/assets/javascripts/competition.js') >= 0) return;  svs.modules.push('/components/tipsen/route-competition/assets/javascripts/competition.js');
"use strict";


const {
  useEffect
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useRouteMatch,
  useHistory
} = ReactRouterDOM;
const {
  Lobby
} = svs.components.marketplaceCompetition.lobby;
const {
  CompetitionProvider
} = svs.components.marketplaceCompetition.competitionContext;
const {
  CompetitionMenuProvider
} = svs.components.marketplaceCompetition.competitionMenu;
const {
  useDraws
} = svs.components.tipsen.routeCompetition;
const {
  useGetCompetitionStatus
} = svs.components.tipsen.hooks;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const {
  useCompetition,
  useCompetitionBranding,
  useIsCompetitionInCurrentProduct
} = svs.components.marketplaceCompetition.services.hooks;
const {
  fetchPlayerCompetitions,
  fetchPlayerCompetitionDrawStatus
} = svs.components.marketplaceCompetition.services.actions.playerCompetitionActions;
const {
  selectPlayerCompetition,
  selectPlayerCompetitionDraws
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;
const {
  competitionHandler
} = svs.components.marketplaceCompetition.competitionHandler;
const {
  CompetitionSubscription
} = svs.components.marketplaceCompetition.competitionSubscription;
const RouteCompetition = () => {
  var _currentEngineDefinti, _competition$details;
  const match = useRouteMatch();
  const currentEngineDefintion = useSelector(selectEngineDefinition);
  let productId = currentEngineDefintion === null || currentEngineDefintion === void 0 || (_currentEngineDefinti = currentEngineDefintion.drawProductIds) === null || _currentEngineDefinti === void 0 ? void 0 : _currentEngineDefinti[0];
  const activeCompetition = competitionHandler().getActiveCompetition(productId);
  const competitionId = activeCompetition === null || activeCompetition === void 0 ? void 0 : activeCompetition.getCompetitionId();
  const competitionStatus = useGetCompetitionStatus(currentEngineDefintion, competitionId);
  const history = useHistory();
  useEffect(() => {
    if (!competitionId && competitionId !== 0 || !competitionStatus) {
      history.replace('/');
    }
  }, [competitionStatus, history, competitionId]);
  const competition = useCompetition(competitionId);
  const competitionBranding = useCompetitionBranding(competition === null || competition === void 0 ? void 0 : competition.compType);
  productId = competition === null || competition === void 0 || (_competition$details = competition.details) === null || _competition$details === void 0 ? void 0 : _competition$details.productId;
  const isCompetitionInCurrentProduct = useIsCompetitionInCurrentProduct(productId, currentEngineDefintion === null || currentEngineDefintion === void 0 ? void 0 : currentEngineDefintion.drawProductIds);
  const playerCompetition = useSelector(state => selectPlayerCompetition(state));
  const signUpsCompetitions = playerCompetition.signUps.competitions;
  const hasSignUpsCompetitions = Object.keys(signUpsCompetitions).length > 0;
  const dispatch = useDispatch();
  const isActiveOnly = true;
  useEffect(() => {
    if (isCompetitionInCurrentProduct && !hasSignUpsCompetitions) {
      dispatch(fetchPlayerCompetitions({
        isActiveOnly
      }));
    }
  }, [isCompetitionInCurrentProduct, hasSignUpsCompetitions, competitionId, isActiveOnly, dispatch]);
  const playerCompetitionDraws = useSelector(state => selectPlayerCompetitionDraws(state));
  const hasPlayerCompetitionDraws = Object.keys(playerCompetitionDraws).length > 0;
  const isCurrentCompetitonInPlayerCompetitions = hasSignUpsCompetitions && Boolean(signUpsCompetitions[competitionId]);
  useEffect(() => {
    if (isCompetitionInCurrentProduct && !hasPlayerCompetitionDraws && isCurrentCompetitonInPlayerCompetitions) {
      dispatch(fetchPlayerCompetitionDrawStatus(competitionId));
    }
  }, [isCompetitionInCurrentProduct, hasPlayerCompetitionDraws, isCurrentCompetitonInPlayerCompetitions, competitionId, dispatch]);
  const getMenuItems = () => {
    const menuItems = [];
    const couponItem = {
      label: 'Översikt',
      icon: 'nav-home',
      selectedOnPaths: ['/tavlingar/:competitionName', '/tavlingar/:competitionName/lag/:teamId'],
      to: {
        pathname: ''
      }
    };
    const couponItem2 = {
      label: 'Ställning',
      icon: 'nav-results',
      selectedOnPaths: ['/tavlingar/:competitionName/resultat'],
      to: {
        pathname: '/resultat'
      }
    };
    const couponItem3 = {
      label: 'Om tävlingen',
      icon: 'information',
      selectedOnPaths: ['/tavlingar/:competitionName/om'],
      to: {
        pathname: '/om'
      }
    };
    menuItems.push(couponItem);
    menuItems.push(couponItem2);
    menuItems.push(couponItem3);
    return menuItems;
  };
  return React.createElement(CompetitionProvider, {
    competitionId: competitionId,
    useDraws: useDraws
  }, competitionId && React.createElement(CompetitionSubscription, {
    competitionId: competitionId
  }), React.createElement(CompetitionMenuProvider, {
    branding: competitionBranding,
    items: getMenuItems(),
    relativeTo: match
  }, React.createElement(Lobby, null)));
};
setGlobal('svs.components.tipsen.routeCompetition.RouteCompetition', RouteCompetition);

 })(window);